import { Chat } from '@mui/icons-material';
import {
    Avatar,
    Fab,
    Grid,
    List,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Typography,
} from '@mui/material';
import { ref } from 'firebase/database';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDatabaseListData } from 'reactfire';
import { database } from '../../auth/firebase';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';
import useAuth from '../../hooks/useAuth';

export default function ChatScreen() {
    const navigate = useNavigate();
    const { user } = useAuth();

    const { data: list } = useDatabaseListData(
        ref(database, `chat/list/${user?.username}`)
    );

    return (
        <ExternalScreen title="Chats">
            {list?.length < 1 && <ListEmpty title="No messages yet" />}
            <Grid item xs={12}>
                <List>
                    {list?.map(
                        ({ serverTimestamp, chatterUsername, lastMessage }) => (
                            <ListItemButton
                                sx={{ p: 0 }}
                                key={serverTimestamp}
                                onClick={() =>
                                    navigate(`/chat/${chatterUsername}`, {})
                                }
                            >
                                <ListItemAvatar>
                                    <Avatar>
                                        {chatterUsername?.slice(0, 1)}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <span className="fw-bold">
                                            {chatterUsername}
                                        </span>
                                    }
                                    secondary={`${lastMessage}`}
                                />
                                <>
                                    <Typography
                                        variant="caption"
                                        sx={{ ml: 1 }}
                                    >
                                        {`${moment(serverTimestamp).format(
                                            'MMM DD HH:mm'
                                        )}`}
                                    </Typography>
                                    {/* {!!true && (
                                            <Box
                                                className="bg-success"
                                                sx={{
                                                    ml: 1,
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        )} */}
                                </>
                            </ListItemButton>
                        )
                    )}
                </List>
                <Fab
                    color="primary"
                    variant="extended"
                    sx={{ position: 'fixed', right: 16, bottom: 16 }}
                    onClick={() => navigate('/chat-start')}
                >
                    <Chat sx={{ mr: 1 }} />
                    Start
                </Fab>
            </Grid>
        </ExternalScreen>
    );
}
